"use client";

import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverContent, PopoverTrigger } from "@dc/ui/components";
import type { ReactNode } from "react";
import { useUiLabels } from "../../UiLabels/useUiLabels";
import type { Citation } from "../types";
import { CitationListItem } from "./CitationListItem";
interface CitationPopoverProps {
  citations: Citation[];
  /** The trigger element (button) that opens the popover */
  trigger: ReactNode;
  /** Optional citation ID search parameter name (e.g., 'citationId') */
  citationIdParam?: string;
  /** Optional callback to handle citation click, overrides default navigation behavior */
  onCitationClick?: (citation: Citation) => void;
}

/**
 * Shared popover component for displaying citations in a dropdown
 * Used by both CitationButton (inline citations) and SourcesDropdown (message actions)
 */
export const CitationPopover = t0 => {
  const $ = _c(16);
  const {
    citations,
    trigger,
    citationIdParam,
    onCitationClick
  } = t0;
  const uiLabels = useUiLabels();
  if (citations.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "z-50"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== trigger) {
    t2 = <PopoverTrigger>{trigger}</PopoverTrigger>;
    $[1] = trigger;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = uiLabels.citations.sources;
  let t4;
  if ($[3] !== citationIdParam || $[4] !== citations || $[5] !== onCitationClick) {
    let t5;
    if ($[7] !== citationIdParam || $[8] !== onCitationClick) {
      t5 = (citation, index) => <li key={`${citation.fileUuid}-${index}`} className="rounded-xl px-2 py-1 hover:bg-secondary-700 dark:hover:bg-secondary-300/10"><CitationListItem citation={citation} citationIdParam={citationIdParam} onCitationClick={onCitationClick} /></li>;
      $[7] = citationIdParam;
      $[8] = onCitationClick;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = citations.map(t5);
    $[3] = citationIdParam;
    $[4] = citations;
    $[5] = onCitationClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== uiLabels.citations.sources) {
    t5 = <PopoverContent className="scroll-m-0 overflow-hidden rounded-2xl bg-transparent p-0"><ul aria-label={t3} className="flex max-h-[50vh] min-w-40 max-w-80 flex-col gap-2 overflow-y-auto overflow-x-hidden break-all rounded-2xl bg-bg-indicator-secondary p-2">{t4}</ul></PopoverContent>;
    $[10] = t4;
    $[11] = uiLabels.citations.sources;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <Popover placement="bottom-start" shouldBlockScroll={false} triggerScaleOnOpen={false} disableAnimation={true} shouldFlip={true} classNames={t1}>{t2}{t5}</Popover>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};